import { useEffect, useState } from "react";
import Select from "react-select";
import { showAllTechnician } from "../../api/technician";

export default function DropdownSelectTechnician({ value, onChangeValue }) {
  const [technicianOpt, setTechnicianOpt] = useState([]);

  useEffect(() => {
    const getTechnicians = async () => {
      try {
        const { data } = await showAllTechnician({ role: "technician" });
        let techniciansTemp = data.data.map((technician) => ({
          value: technician.id,
          label: technician.name,
        }));
        setTechnicianOpt(techniciansTemp);
      } catch (error) {
        console.error(error);
      }
    };

    getTechnicians();
  }, []);

  return (
    <Select
      value={value}
      isClearable
      placeholder="Pilih Teknisi"
      onChange={(selected) => onChangeValue(selected)}
      options={technicianOpt}
    />
  );
}
